module.exports = __webpack_public_path__ + "img/防己.1ce1d57b.jpg";